import { EvalPagePrefetcher } from 'features/knowledgeDocumentViewer/components/metadata/EvalPagePrefetcher'
import { selectActivePrefetchJobs } from 'features/knowledgeDocumentViewer/utils/pageMetadataEvalPrefetch'
import type { MetadataEvalSampledPage } from 'features/knowledgeDocumentViewer/utils/pageMetadataEvalSampling'
import type { EvalPageTrail } from 'features/knowledgeDocumentViewer/utils/pageMetadataEvalTrail'
import { useCallback, useState } from 'react'

export function EvalPagePrefetchers({
  queuedPages,
  trail,
  siteId,
}: {
  queuedPages: readonly MetadataEvalSampledPage[]
  trail: EvalPageTrail
  siteId: string
}) {
  const [completed, setCompleted] = useState<ReadonlySet<string>>(new Set())
  const onSettled = useCallback((id: string) => {
    setCompleted((previous) =>
      previous.has(id) ? previous : new Set([...previous, id])
    )
  }, [])
  const jobs = selectActivePrefetchJobs(trail, queuedPages, completed)
  return (
    <>
      {jobs.map(({ page, hiRes, jobId }) => (
        <EvalPagePrefetcher
          key={page.page_id}
          jobId={jobId}
          onSettled={onSettled}
          siteId={siteId}
          documentId={page.document_id}
          pageNum={page.page_num}
          hiRes={hiRes}
        />
      ))}
    </>
  )
}
